import { createFileRoute } from "@tanstack/react-router"
import { getUseCaseBySlug } from "@/data/use-cases/use-cases-registry"
import { getUseCaseBySlugForLanguage } from "@/data/use-cases/use-cases-i18n"
import { useTranslation } from "@/lib/i18n"
import UseCasePageLayout from "@/components/use-cases/UseCasePageLayout"

const fallback = getUseCaseBySlug("instagram-story-reply-automation")!

export const Route = createFileRoute("/$lang/use-case/instagram-story-reply-automation")({
  component: LangStoryRepliesPage,
})

function LangStoryRepliesPage() {
  const { language } = useTranslation()
  const data = getUseCaseBySlugForLanguage(language, "instagram-story-reply-automation") || fallback
  return <UseCasePageLayout data={data} />
}
